module.exports = __webpack_public_path__ + "static/img/tooltip-adcs-design.32c87a8.png";